import { HeartBank } from "../../../managers/HeartBank.ts";
import { Chests } from "../../../models/Chests.ts";
import { User } from "firebase/auth";
import template from "./hb-vault.mjs";
import { html, render } from "lit-html";
import { repeat } from "lit-html/directives/repeat.js";
import { until } from "lit-html/directives/until.js";
import {
    getSafe,
    getLocker,
    downloadFile,
    isIOS,
    fetchBlob
} from "../../global.ts";
import { B3 } from "../../../models/3B.ts";
import { Me } from "../../../managers/Me.ts";
import { HbMain } from "../hb-main.ts";
import { Crypto } from "../../../models/Crypto.ts";
import { B, getHero, getDeviceID, isUSDZ } from "../../global.ts";
import { Chest } from "../../../managers/Chest.ts";
import { Stamps } from "../../../models/Stamps.ts";

import { fs } from "../../../firebase.ts";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

import { Calendar, Options } from "vanilla-calendar-pro";
import "vanilla-calendar-pro/styles/index.css";

import { Modal, initDropdowns } from "flowbite";
import type { ModalOptions, ModalInterface, InstanceOptions } from "flowbite";

// TODO: cloud chest: need to do check if allowed to see data! // if isEncrypted: make sure user is logged in before showing data (just show hidden icon): for now will show even if not logged in
//TODO: Later: import and export all chests! // if high demand for this
// bug: can't do rounded corners for images

export class HbVault extends HTMLElement {
    private heartbank = new HeartBank();
    private stamps = new Stamps();
    private crypto = new Crypto();
    private me = new Me();
    private chests = new Chests();
    private b3 = new B3();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;
    private did = getDeviceID();

    private vault: HTMLElement;
    private stamp: HTMLButtonElement;
    private clear: HTMLButtonElement;
    private mints: HTMLOListElement;
    private mines: HTMLOListElement;

    private calendarPro: Calendar;
    private calendar: HTMLElement;
    private backdrop: HTMLElement;
    private datepicker: HTMLButtonElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;
    private date = ""; // date input format: 2025-10-10
    //private calendar: HTMLInputElement; // works on chrome but not safari bc cannot hide input
    //private pickerOpen = false;
    private clearBtn: HTMLButtonElement;
    private todayBtn: HTMLButtonElement;
    private closeBtn: HTMLButtonElement;

    private holds: HTMLSelectElement;
    private all: HTMLSelectElement;
    private lockers: HTMLOptGroupElement;
    private safes: HTMLOptGroupElement;
    private mintingHistory: HTMLButtonElement;
    private miningHistory: HTMLButtonElement;

    private type: "mint" | "mine" = "mint";
    private filter = ""; // by key
    private mintsCount = 0;
    private minesCount = 0;

    private readonly link = "https://vault.333.eco/#/mine";

    constructor() {
        super();
        render(template(null), this);

        this.vault = this.querySelector("#hb-vault")!;
        this.stamp = this.querySelector("#hb-vault-stamp")!;
        this.clear = this.querySelector("#hb-vault-clear")!;
        this.mints = this.querySelector("#hb-vault-mints")!;
        this.mines = this.querySelector("#hb-vault-mines")!;

        this.datepicker = this.querySelector("#hb-vault-datepicker")!;
        this.backdrop = this.querySelector("#hb-vault-backdrop")!;
        this.calendar = this.querySelector("#hb-vault-calendar")!;
        this.clearBtn = this.querySelector("#hb-vault-calendar-clear")!;
        this.todayBtn = this.querySelector("#hb-vault-calendar-today")!;
        this.closeBtn = this.querySelector("#hb-vault-calendar-close")!;
        this.previous = this.querySelector("#hb-vault-previous")!;
        this.next = this.querySelector("#hb-vault-next")!;

        this.holds = this.querySelector("#hb-vault-holds")!;
        this.all = this.holds.firstElementChild as HTMLSelectElement;
        this.safes = this.holds.firstElementChild
            ?.nextElementSibling as HTMLOptGroupElement;
        this.lockers = this.holds.lastElementChild as HTMLOptGroupElement;
        this.mintingHistory = this.querySelector("#hb-vault-mint")!;
        this.miningHistory = this.querySelector("#hb-vault-mine")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        const instanceOptions: InstanceOptions = {
            id: "hb-vault",
            override: true
        };

        this.modal = new Modal(this.vault, modalOptions, instanceOptions);

        const config: Options = {
            type: "default", // 'month', 'year', 'multiple'
            locale: "en-US",
            monthsToSwitch: 1,
            dateToday: "today",
            enableJumpToSelectedDate: true,
            displayDatesOutside: false,
            themeAttrDetect: "html.dark", // doesn't work; only works with system theme
            firstWeekday: 1, // Monday as first day
            selectionDatesMode: "single", // other modes: 'multiple', 'multiple-ranged'
            onClickDate: (self, event) => {
                const el = event.target as HTMLElement;
                const date = new Date(el.getAttribute("aria-label")!);
                this.date = date.toISOString().split("T")[0];
                this.backdrop.classList.add("hidden");
                this.backdrop.classList.remove("flex");
                this.render(this.heartbank.user);
            }
        };

        this.calendarPro = new Calendar(this.calendar, config);
        this.calendarPro.init();
    }

    connectedCallback() {
        this.stamp.addEventListener("click", () => {
            if (
                confirm(
                    "Are you sure you want to un-link the B-Stamp you scanned?"
                )
            ) {
                localStorage.removeItem("stamp");
                this.renderStamp();
            }
        });

        this.datepicker.addEventListener(
            "click",
            this.renderCalendar.bind(this, true)
        );
        this.closeBtn.addEventListener(
            "click",
            this.renderCalendar.bind(this, false)
        );

        this.clearBtn.addEventListener("click", () => {
            this.date = "";
            this.renderCalendar(false);
            this.render(this.heartbank.user);
        });
        this.todayBtn.addEventListener("click", () => {
            const today = new Date().toISOString().split("T")[0];
            this.calendarPro.set({
                selectedDates: [today]
            });
            this.date = today;
            this.renderCalendar(false);
            this.render(this.heartbank.user);
        });

        this.previous.addEventListener("click", this.setDay.bind(this, false));
        this.next.addEventListener("click", this.setDay.bind(this, true));

        // this.datepicker.addEventListener("click", () => {
        //     if (!this.pickerOpen) {
        //         this.calendar.showPicker();
        //         this.pickerOpen = true;
        //     } else {
        //         this.calendar.blur(); // this closes it in most browsers
        //         this.pickerOpen = false;
        //     }
        // });
        // this.datepicker.addEventListener("blur", () => {
        //     this.pickerOpen = false;
        // });
        // this.calendar.addEventListener("change", () => {
        //     this.pickerOpen = false;
        //     this.date = this.calendar.value;
        //     this.render(this.heartbank.user);
        // });
        // const observer = new MutationObserver(() => {
        //     this.date = this.calendar.value;
        //     this.render(this.heartbank.user);
        // });
        // observer.observe(this.calendar, {
        //     attributes: true,
        //     attributeFilter: ["value"]
        // });

        this.holds.addEventListener("change", () => {
            this.filter = this.holds.value;
            this.render(this.heartbank.user);
        });

        this.clear.addEventListener("click", async () => {
            if (
                confirm(
                    `Are you sure you want to delete all the ${
                        this.type === "mint" ? "minted" : "mined"
                    } B-Chests stored on this device?`
                )
            ) {
                await this.chests.removeAll(this.type);
                this.render(this.heartbank.user);
            }
        });

        this.mintingHistory.addEventListener("click", () => {
            this.type = "mint";
            this.mints.classList.remove("hidden");
            this.mines.classList.add("hidden");
            this.mintingHistory.classList.add("underline");
            this.miningHistory.classList.remove("underline");
            //this.clear.classList.toggle("hidden", this.mintsCount === 0);
            this.all.textContent = "All Minted B-Chests";
            this.render(this.heartbank.user);
        });
        this.miningHistory.addEventListener("click", () => {
            this.type = "mine";
            this.mints.classList.add("hidden");
            this.mines.classList.remove("hidden");
            this.mintingHistory.classList.remove("underline");
            this.miningHistory.classList.add("underline");
            //this.clear.classList.toggle("hidden", this.minesCount === 0);
            this.all.textContent = "All Mined B-Chests";
            this.render(this.heartbank.user);
        });

        this.heartbank.addAuthStateListener((user) => {
            this.renderHolds(user);
            this.render(user);

            const fragments = window.location.hash.split("/");
            this.renderTrash(fragments[2] as "mint" | "mine");
        });
    }

    // TODO: show spinner if await is too long
    async show(page: "mint" | "mine") {
        this.filter = "";
        this.renderHolds(this.heartbank.user); // await
        page === "mint"
            ? this.mintingHistory.click()
            : this.miningHistory.click();
        await this.renderStamp();
        this.modal.show();
    }

    back(page: "mint" | "mine") {
        if (page === "mint") {
            this.type = "mint";
            this.mints.classList.remove("hidden");
            this.mines.classList.add("hidden");
            this.mintingHistory.classList.add("underline");
            this.miningHistory.classList.remove("underline");
            //this.clear.classList.toggle("hidden", this.mintsCount === 0);
            //this.all.textContent = "All Minted B-Chests";
            //this.render(this.heartbank.user);
        } else {
            this.type = "mine";
            this.mints.classList.add("hidden");
            this.mines.classList.remove("hidden");
            this.mintingHistory.classList.remove("underline");
            this.miningHistory.classList.add("underline");
            //this.clear.classList.toggle("hidden", this.minesCount === 0);
            if (this.mines.childElementCount === 0) {
                this.all.textContent = "All Mined B-Chests";
                this.render(this.heartbank.user);
            }
        }
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private renderCalendar(isOpen: boolean) {
        this.backdrop.classList.toggle("hidden", !isOpen);
        this.backdrop.classList.toggle("flex", isOpen);
    }

    private async setDay(isNext: boolean) {
        this.previous.disabled = true;
        this.next.disabled = true;

        const date = this.date ? new Date(this.date) : new Date();
        date.setDate(date.getDate() + (isNext ? 1 : -1));
        const nextDay = date.toISOString().split("T")[0];

        //this.calendar.value = nextDay;
        this.calendarPro.set({
            selectedDates: [nextDay]
        });
        this.date = nextDay;
        await this.render(this.heartbank.user);

        this.previous.disabled = false;
        this.next.disabled = false;
    }

    private async renderHolds(user: User | null) {
        // lockers
        const lockers = await this.crypto.getAllKeys({
            sort: (a: any, b: any) => a.name.localeCompare(b.name)
        });
        this.lockers.innerHTML = ""; // need to be after await

        lockers.forEach((locker: any) => {
            const option = document.createElement("option");
            option.value = locker.key;
            option.textContent =
                (getHero().trustkey === locker.key ? "🌐" : "🔐") + locker.name;
            this.lockers.append(option);
        });

        // safes
        if (user?.phoneNumber) {
            const keysQuery = query(
                collection(fs, "users", user.uid, "heartkeys"),
                orderBy("name")
            );
            const keysSnap = await getDocs(keysQuery);
            this.safes.innerHTML = ""; // need to be after await

            keysSnap.forEach((doc) => {
                const { name, isPrimary } = doc.data();
                const option = document.createElement("option");
                option.value = doc.id;
                option.textContent = (isPrimary ? "🌐" : "🔒") + name;
                this.safes.append(option);
            });

            this.safes.classList.remove("hidden");
        } else {
            this.safes.innerHTML = "";
            this.safes.classList.add("hidden");
        }
    }

    private renderTrash(type: "mint" | "mine") {
        this.clear.classList.toggle(
            "hidden",
            type === "mint" ? this.mintsCount === 0 : this.minesCount === 0
        );
    }

    private async renderStamp() {
        const stamp = localStorage.getItem("stamp");
        const isStamp = stamp && !(await this.stamps.isMinted(stamp));
        this.stamp.classList.toggle("hidden", !isStamp);
        this.stamp.classList.toggle("inline-flex", !!isStamp);
    }

    private async renderStampIcon(uid: string, id: string, v: number) {
        const isStamp = uid ? await this.stamps.isStamp(uid, id) : false;
        return html`
            <svg
                class="w-4 h-4 text-blue-800 dark:text-blue-300"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 640 640">
                <path
                    transform="${isStamp ? "rotate(45 300 300)" : ""}"
                    d="${isStamp
                        ? "M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z"
                        : v === 0
                          ? "M32 400C32 479.5 96.5 544 176 544L480 544C550.7 544 608 486.7 608 416C608 364.4 577.5 319.9 533.5 299.7C540.2 286.6 544 271.7 544 256C544 203 501 160 448 160C430.3 160 413.8 164.8 399.6 173.1C375.5 127.3 327.4 96 272 96C192.5 96 128 160.5 128 240C128 248 128.7 255.9 129.9 263.5C73 282.7 32 336.6 32 400z"
                          : v === 1
                            ? "M160 224L224 224L224 160L160 160L160 224zM96 144C96 117.5 117.5 96 144 96L240 96C266.5 96 288 117.5 288 144L288 240C288 266.5 266.5 288 240 288L144 288C117.5 288 96 266.5 96 240L96 144zM160 480L224 480L224 416L160 416L160 480zM96 400C96 373.5 117.5 352 144 352L240 352C266.5 352 288 373.5 288 400L288 496C288 522.5 266.5 544 240 544L144 544C117.5 544 96 522.5 96 496L96 400zM416 160L416 224L480 224L480 160L416 160zM400 96L496 96C522.5 96 544 117.5 544 144L544 240C544 266.5 522.5 288 496 288L400 288C373.5 288 352 266.5 352 240L352 144C352 117.5 373.5 96 400 96zM384 416C366.3 416 352 401.7 352 384C352 366.3 366.3 352 384 352C401.7 352 416 366.3 416 384C416 401.7 401.7 416 384 416zM384 480C401.7 480 416 494.3 416 512C416 529.7 401.7 544 384 544C366.3 544 352 529.7 352 512C352 494.3 366.3 480 384 480zM480 512C480 494.3 494.3 480 512 480C529.7 480 544 494.3 544 512C544 529.7 529.7 544 512 544C494.3 544 480 529.7 480 512zM512 416C494.3 416 480 401.7 480 384C480 366.3 494.3 352 512 352C529.7 352 544 366.3 544 384C544 401.7 529.7 416 512 416zM480 448C480 465.7 465.7 480 448 480C430.3 480 416 465.7 416 448C416 430.3 430.3 416 448 416C465.7 416 480 430.3 480 448z"
                            : "M180.7 97.8C185.2 91.7 192.4 88 200 88L440 88C447.6 88 454.8 91.6 459.3 97.8L571.3 249.8C578.1 259 577.4 271.7 569.8 280.2L337.8 536.2C333.3 541.2 326.8 544.1 320 544.1C313.2 544.1 306.8 541.2 302.2 536.2L70.2 280.2C62.5 271.7 61.9 259 68.7 249.8L180.7 97.8zM219.2 137.6C215.9 140.1 215 144.6 217.1 148.1L274.5 243.8L127.3 256C123.2 256.3 120 259.8 120 264C120 268.2 123.2 271.6 127.3 272L319.3 288C319.7 288 320.2 288 320.6 288L512.6 272C516.7 271.7 519.9 268.2 519.9 264C519.9 259.8 516.7 256.4 512.6 256L365.4 243.7L422.8 148.1C424.9 144.6 424 140 420.7 137.6C417.4 135.2 412.8 135.6 410 138.6L320 236.2L229.9 138.6C227.1 135.6 222.5 135.2 219.2 137.6z"}" />
            </svg>
        `;
    }

    private async render(user: User | null, isScroll = true) {
        this.main.showSpinner();
        const history = this.type === "mint" ? this.mints : this.mines;
        const chests =
            this.type === "mint"
                ? await this.chests.getMints(
                      user?.uid || "",
                      this.date,
                      this.filter
                  )
                : await this.chests.getMines(
                      this.did,
                      user?.uid || "",
                      this.date,
                      this.filter
                  );
        if (this.type === "mint") this.mintsCount = chests.length; //TODO: filter for local then re-render trash icon
        if (this.type === "mine") this.minesCount = chests.length; //TODO: filter for local then re-render trash icon
        this.renderTrash(this.type); // order important

        if (chests.length === 0) {
            history.style.color = "gray";
            history.classList.remove("border-l");
            render(
                user
                    ? `There are currently no ${
                          this.type === "mint" ? "minted" : "mined"
                      } B-Chests stored inside your Cloud Vault or on this device${
                          this.date ? " for " + this.date : ""
                      }`
                    : `There are currently no ${
                          this.type === "mint" ? "minted" : "mined"
                      } B-Chests stored on this device${
                          this.date ? " for " + this.date : ""
                      }`,
                history
            );
        } else {
            history.style.color = "";
            history.classList.add("border-l");
            render(
                html`${repeat(
                    chests,
                    (chest) => `${chest.id}/${this.type}`, // for efficient re-render
                    (chest, index) => {
                        const data = JSON.parse(
                            decodeURIComponent(chest.data.split("/")[1])
                        );
                        const manager = new Chest(chest, data);
                        const url = `${B}/v/${chest.id}`;
                        return html`
                            <li
                                class="${index + 1 === chests.length
                                    ? "mb-5"
                                    : "mb-10"} ms-6">
                                <button
                                    @click=${async () => {
                                        const stamp =
                                            localStorage.getItem("stamp");
                                        const isStamp =
                                            stamp &&
                                            !(await this.stamps.isMinted(
                                                stamp
                                            ));
                                        const stamps =
                                            await this.stamps.stampCount(
                                                user?.uid || "",
                                                chest.id
                                            );
                                        if (
                                            isStamp &&
                                            user &&
                                            data.b.v === 0 &&
                                            confirm(
                                                stamps
                                                    ? `You have already linked ${stamps} Silver B-Stamp${
                                                          stamps === 1
                                                              ? ""
                                                              : "s"
                                                      } to this Silver B-Chest.\n\nWould you like to link this Silver B-Chest to the Silver B-Stamp you scanned?`
                                                    : "Would you like to link this Silver B-Chest to the Silver B-Stamp you scanned?"
                                            )
                                        ) {
                                            await this.stamps.link(
                                                stamp,
                                                user.uid,
                                                chest.id,
                                                true
                                            );
                                            localStorage.removeItem("stamp");
                                            await this.renderStamp();
                                            this.render(user, false);
                                            // alert(
                                            //     "The B-Stamp you scanned is now linked to this Silver B-Chest!"
                                            // );
                                        } else if (!isStamp && stamps) {
                                            alert(
                                                `You have linked ${stamps} Silver B-Stamp${
                                                    stamps === 1 ? "" : "s"
                                                } to this Silver B-Chest.`
                                            );
                                        } else if (!isStamp && data.b.v === 0) {
                                            if (
                                                confirm(
                                                    "To link a Silver B-Stamp to this Silver B-Chest, please scan a blank B-Stamp first, then tap here again.\n\nWould you like to scan one now?"
                                                )
                                            ) {
                                                localStorage.setItem(
                                                    "redirect-mine",
                                                    window.location.hash
                                                );
                                                window.location.hash = "#/mine";
                                            }
                                        } else if (data.b.v !== 0) {
                                            alert(
                                                "Only Silver B-Chests stored inside your Cloud Vault can be linked to Silver B-Stamps."
                                            );
                                        }
                                    }}
                                    class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full start-1 ring-8 ring-white dark:ring-gray-700 dark:bg-blue-900">
                                    ${until(
                                        this.renderStampIcon(
                                            user?.uid || "",
                                            chest.id,
                                            data.b.v
                                        ),
                                        ""
                                    )}
                                </button>
                                <h3
                                    class="w-full inline-flex justify-between items-center mb-1 text-lg font-semibold text-gray-900 dark:text-white">
                                    <button
                                        @click=${async () => {
                                            if (
                                                data.b.v !== 0 ||
                                                user?.uid === chest.uid
                                            ) {
                                                const name = prompt(
                                                    "Enter new name for this B-Chest:",
                                                    chest.name
                                                );
                                                if (name) {
                                                    await this.chests.rename(
                                                        chest.id,
                                                        name,
                                                        data.b.v === 0
                                                    );
                                                    this.render(user, false);
                                                }
                                            }
                                        }}>
                                        ${chest.name.truncate2(22)}
                                        <span
                                            class="${data.b.v !== 0 ||
                                            user?.uid === chest.uid
                                                ? ""
                                                : "hidden"}">
                                            <!--✏️-->
                                        </span>
                                    </button>
                                    <span class="text-base">
                                        ${manager.isTimeLocked()
                                            ? html`
                                                  <svg
                                                      @click=${() =>
                                                          alert(
                                                              `This B-Chest is time-locked until ${manager.timelock?.toFormattedString()}.`
                                                          )}
                                                      class="w-4 h-4"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      fill="orangered"
                                                      viewBox="0 0 512 512">
                                                      <path
                                                          d="M504.4 132.5c-4.5 10.5-18.4 9.8-24.9 .4-27.8-40-66.1-72.2-111-92.6-10.4-4.7-13.7-18.3-4.1-24.6 15-9.9 33-15.7 52.3-15.7 52.6 0 95.2 42.6 95.2 95.2 0 13.2-2.7 25.8-7.6 37.3zm-471.9 .4c-6.5 9.4-20.5 10.1-24.9-.4-4.9-11.5-7.6-24.1-7.6-37.3 0-52.6 42.6-95.2 95.2-95.2 19.3 0 37.3 5.8 52.3 15.7 9.6 6.3 6.3 19.9-4.1 24.6-44.8 20.4-83.1 52.6-111 92.6zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-49-49 0-94.1z" />
                                                  </svg>
                                              `
                                            : data.b.t
                                              ? html`
                                                    <svg
                                                        @click=${() =>
                                                            alert(
                                                                `This B-Chest was time-locked for ${manager.timelock?.toFormattedString()}.`
                                                            )}
                                                        class="w-4 h-4"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="${data.n.e
                                                            ? "black"
                                                            : "forestgreen"}"
                                                        viewBox="0 0 512 512">
                                                        <path
                                                            d="M504.4 132.5c-4.5 10.5-18.4 9.8-24.9 .4-27.8-40-66.1-72.2-111-92.6-10.4-4.7-13.7-18.3-4.1-24.6 15-9.9 33-15.7 52.3-15.7 52.6 0 95.2 42.6 95.2 95.2 0 13.2-2.7 25.8-7.6 37.3zm-471.9 .4c-6.5 9.4-20.5 10.1-24.9-.4-4.9-11.5-7.6-24.1-7.6-37.3 0-52.6 42.6-95.2 95.2-95.2 19.3 0 37.3 5.8 52.3 15.7 9.6 6.3 6.3 19.9-4.1 24.6-44.8 20.4-83.1 52.6-111 92.6zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-49-49 0-94.1z" />
                                                    </svg>
                                                `
                                              : data.b.e === 1
                                                ? html`
                                                      <svg
                                                          @click=${() =>
                                                              alert(
                                                                  "Only humans can view this B-Chest."
                                                              )}
                                                          class="w-4 h-4"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          fill="red"
                                                          viewBox="0 0 512 512">
                                                          <path
                                                              d="M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6-15.2 5-18.7 23.7-8.3 35.9 7.1 8.3 18.8 10.8 29.4 7.9 10.6-2.9 21.8-4.4 33.4-4.4 70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3-1.7 14.6 9.4 27.8 24.2 27.8 11.8 0 21.9-8.6 23.3-20.3 3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4-23.1 29.8-36.8 67.1-36.8 107.7l0 24.9c0 24.2-2.6 48.4-7.8 71.9-3.4 15.6 7.9 31.1 23.9 31.1 10.5 0 19.9-7 22.2-17.3 6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1 7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1-3.8 14.3 6.7 29 21.5 29 9.5 0 17.9-6.2 20.4-15.4 10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9-2.7 13.9 7.7 27.2 21.8 27.2 10.2 0 19-7 21-17 7.7-38.8 11.6-78.3 11.6-118.1l0-24.9c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9z" />
                                                      </svg>
                                                  `
                                                : data.n.e
                                                  ? html`
                                                        <svg
                                                            @click=${() =>
                                                                alert(
                                                                    "The Silver inside this B-Chest is encrypted."
                                                                )}
                                                            class="w-4 h-4"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="black"
                                                            viewBox="0 0 576 512">
                                                            <path
                                                                d="M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.4-96.4c2.7-2.4 5.4-4.8 8-7.2 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-56.8 0-105.6 18.2-146 44.2L41-24.9zM204.5 138.7c23.5-16.8 52.4-26.7 83.5-26.7 79.5 0 144 64.5 144 144 0 31.1-9.9 59.9-26.7 83.5l-34.7-34.7c12.7-21.4 17-47.7 10.1-73.7-13.7-51.2-66.4-81.6-117.6-67.9-8.6 2.3-16.7 5.7-24 10l-34.7-34.7zM325.3 395.1c-11.9 3.2-24.4 4.9-37.3 4.9-79.5 0-144-64.5-144-144 0-12.9 1.7-25.4 4.9-37.3L69.4 139.2c-32.6 36.8-55 75.8-66.9 104.5-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 37.3 0 71.2-7.9 101.5-20.6l-64.2-64.2z" />
                                                        </svg>
                                                    `
                                                  : html`
                                                        <svg
                                                            @click=${() =>
                                                                alert(
                                                                    "Anyone can view this B-Chest."
                                                                )}
                                                            class="w-4 h-4 fill-green-500"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 512 512">
                                                            <path
                                                                d="M351.9 280l-190.9 0c2.9 64.5 17.2 123.9 37.5 167.4 11.4 24.5 23.7 41.8 35.1 52.4 11.2 10.5 18.9 12.2 22.9 12.2s11.7-1.7 22.9-12.2c11.4-10.6 23.7-28 35.1-52.4 20.3-43.5 34.6-102.9 37.5-167.4zM160.9 232l190.9 0C349 167.5 334.7 108.1 314.4 64.6 303 40.2 290.7 22.8 279.3 12.2 268.1 1.7 260.4 0 256.4 0s-11.7 1.7-22.9 12.2c-11.4 10.6-23.7 28-35.1 52.4-20.3 43.5-34.6 102.9-37.5 167.4zm-48 0C116.4 146.4 138.5 66.9 170.8 14.7 78.7 47.3 10.9 131.2 1.5 232l111.4 0zM1.5 280c9.4 100.8 77.2 184.7 169.3 217.3-32.3-52.2-54.4-131.7-57.9-217.3L1.5 280zm398.4 0c-3.5 85.6-25.6 165.1-57.9 217.3 92.1-32.7 159.9-116.5 169.3-217.3l-111.4 0zm111.4-48C501.9 131.2 434.1 47.3 342 14.7 374.3 66.9 396.4 146.4 399.9 232l111.4 0z" />
                                                        </svg>
                                                    `}
                                    </span>
                                </h3>
                                <address
                                    @click=${() =>
                                        alert(
                                            `The precise location of this B-Chest is ${
                                                data.l.h
                                                    ? "encrypted"
                                                    : "public"
                                            }.`
                                        )}
                                    class="flex mb-2 text-sm not-italic font-medium text-gray-600 dark:text-gray-400">
                                    <svg
                                        class="mr-2 w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="${data.l.h ? "gray" : "orange"}"
                                        viewBox="0 0 384 512">
                                        <path
                                            d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                    </svg>
                                    ${until(
                                        manager.renderLocation(),
                                        html`<span class="opacity-50">
                                            Unknown Location
                                        </span>`
                                    )}
                                </address>
                                <time
                                    class="block mb-3 text-sm italic font-normal leading-none text-gray-600 dark:text-gray-500"
                                    >${this.type === "mint"
                                        ? "Minted"
                                        : "Mined"}
                                    on ${chest.date.toFormattedString()}</time
                                >
                                <div
                                    class="inline-flex w-full rounded-md shadow-xs"
                                    role="group">
                                    <!-- cloud Dropdown menu -->
                                    <button
                                        type="button"
                                        data-dropdown-toggle="hb-vault-mint-cloud-${this
                                            .type}-${index}"
                                        class="${data.b.v === 0
                                            ? "inline-flex"
                                            : "hidden"} rounded-s-lg w-full justify-center items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        <svg
                                            class="w-3 h-3"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 576 512">
                                            <path
                                                d="M0 336c0 79.5 64.5 144 144 144l304 0c70.7 0 128-57.3 128-128 0-51.6-30.5-96.1-74.5-116.3 6.7-13.1 10.5-28 10.5-43.7 0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144 0 8 .7 15.9 1.9 23.5-56.9 19.2-97.9 73.1-97.9 136.5z" />
                                        </svg>
                                    </button>
                                    <div
                                        id="hb-vault-mint-cloud-${this
                                            .type}-${index}"
                                        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-36 dark:bg-gray-700">
                                        <ul
                                            class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                            aria-labelledby="hb-vault-mint-cloud-${this
                                                .type}-${index}">
                                            <li>
                                                <button
                                                    @click=${async () =>
                                                        manager.isTimeLocked()
                                                            ? this.shareTimeLock(
                                                                  chest.name,
                                                                  manager.getTitle(
                                                                      "timelock"
                                                                  ),
                                                                  await manager.getTimeLockText(),
                                                                  url,
                                                                  chest.coverVideo
                                                              )
                                                            : this.shareLink(
                                                                  chest.name,
                                                                  manager.getTitle(),
                                                                  await manager.getPublicText(
                                                                      "cloud"
                                                                  ),
                                                                  url,
                                                                  chest.avatar as unknown as string,
                                                                  chest.code as unknown as string,
                                                                  chest.coverVideo
                                                              )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 512 512">
                                                        <path
                                                            d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                                                    </svg>
                                                    Share Link
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    @click=${() =>
                                                        this.copy(
                                                            url,
                                                            !!data.b.s
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z" />
                                                    </svg>
                                                    Copy Link
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- code Dropdown menu -->
                                    <button
                                        data-dropdown-toggle="hb-vault-mint-code-${this
                                            .type}-${index}"
                                        type="button"
                                        class="${data.b.v === 0
                                            ? ""
                                            : "rounded-s-lg"} 
                                            ${data.b.v === 0 || data.b.v === 1
                                            ? "inline-flex"
                                            : "hidden"} w-full justify-center items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-r border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        <svg
                                            class="w-3 h-3"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 448 512">
                                            <path
                                                d="M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z" />
                                        </svg>
                                    </button>
                                    <div
                                        id="hb-vault-mint-code-${this
                                            .type}-${index}"
                                        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-52 dark:bg-gray-700">
                                        <ul
                                            class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                            aria-labelledby="hb-vault-mint-code-${this
                                                .type}-${index}">
                                            <li>
                                                <button
                                                    @click=${async () =>
                                                        chest.avatar
                                                            ? manager.isTimeLocked()
                                                                ? this.shareTimeLock(
                                                                      chest.name,
                                                                      manager.getTitle(
                                                                          "timelock"
                                                                      ),
                                                                      await manager.getTimeLockText(),
                                                                      url,
                                                                      chest.coverVideo
                                                                  )
                                                                : this.shareLink(
                                                                      chest.name,
                                                                      manager.getTitle(),
                                                                      await manager.getPublicText(
                                                                          "cloud"
                                                                      ),
                                                                      url,
                                                                      chest.avatar as unknown as string,
                                                                      chest.code as unknown as string,
                                                                      chest.coverVideo
                                                                  )
                                                            : this.shareCode(
                                                                  chest.name,
                                                                  manager.getTitle(),
                                                                  await manager.getPublicText(
                                                                      "code"
                                                                  ),
                                                                  chest.code as Blob,
                                                                  chest.coverVideo
                                                              )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 512 512">
                                                        <path
                                                            d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                                                    </svg>
                                                    Share QR Code
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    @click=${() =>
                                                        this.copyCode(
                                                            chest.code as
                                                                | string
                                                                | Blob,
                                                            !!data.b.s
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z" />
                                                    </svg>
                                                    Copy QR Code
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    @click=${() =>
                                                        this.downloadCode(
                                                            chest.name,
                                                            chest.code as
                                                                | string
                                                                | Blob
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                    </svg>
                                                    Download QR Code
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    @click=${() =>
                                                        this.print(
                                                            chest.code as
                                                                | string
                                                                | Blob
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 512 512">
                                                        <path
                                                            d="M64 64C64 28.7 92.7 0 128 0L341.5 0c17 0 33.3 6.7 45.3 18.7l42.5 42.5c12 12 18.7 28.3 18.7 45.3l0 37.5-384 0 0-80zM0 256c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 96c0 17.7-14.3 32-32 32l-32 0 0 64c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-64-32 0c-17.7 0-32-14.3-32-32l0-96zM128 416l0 32 256 0 0-96-256 0 0 64zM456 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z" />
                                                    </svg>
                                                    Print QR Code
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- crystal Dropdown menu -->
                                    <button
                                        data-dropdown-toggle="hb-vault-mint-crystal-${this
                                            .type}-${index}"
                                        type="button"
                                        class="${data.b.v !== 0 &&
                                        data.b.v === 2
                                            ? "rounded-s-lg"
                                            : ""} ${data.b.v === 0
                                            ? "rounded-e-lg"
                                            : ""} inline-flex w-full justify-center items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        <svg
                                            class="w-3 h-3"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 512 512">
                                            <path
                                                d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5L210.5 179.8 63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8l-147.2-12.3 57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z" />
                                        </svg>
                                    </button>
                                    <div
                                        id="hb-vault-mint-crystal-${this
                                            .type}-${index}"
                                        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-52 dark:bg-gray-700">
                                        <ul
                                            class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                            aria-labelledby="hb-vault-mint-crystal-${this
                                                .type}-${index}">
                                            <li>
                                                <button
                                                    @click=${async () =>
                                                        this.shareCrystal(
                                                            chest.name,
                                                            manager.getTitle(),
                                                            await manager.getPublicText(
                                                                "crystal"
                                                            ),
                                                            data.b.v === 0
                                                                ? url
                                                                : chest.data,
                                                            chest.coverVideo
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 512 512">
                                                        <path
                                                            d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                                                    </svg>
                                                    Share 3B Crystal
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    @click=${() =>
                                                        this.downloadCrystal(
                                                            chest.name,
                                                            data.b.v === 0
                                                                ? url
                                                                : chest.data
                                                        )}
                                                    class="inline-flex px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <svg
                                                        class="w-4 h-4 me-2"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                    </svg>
                                                    Download 3B Crystal
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- delete button -->
                                    <button
                                        type="button"
                                        @click=${async () => {
                                            if (
                                                confirm(
                                                    `Are you sure you want to delete ${chest.name} from your device?`
                                                )
                                            ) {
                                                await this.chests.remove(
                                                    chest.id
                                                );
                                                this.render(user, false);
                                            }
                                        }}
                                        class="${data.b.v === 0
                                            ? "hidden"
                                            : "inline-flex"} w-full justify-center items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        <svg
                                            class="w-3 h-3"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 448 512">
                                            <path
                                                d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
                                        </svg>
                                    </button>
                                </div>
                                <div
                                    class="mt-2 w-full text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                    <div
                                        class="inline-flex justify-between items-center w-full px-4 py-2 text-sm font-medium rounded-b-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                        ${this.type === "mint"
                                            ? this.renderAvatar(
                                                  true,
                                                  data.f.p,
                                                  user?.uid || null //chest.uid
                                              )
                                            : this.renderAvatar(
                                                  false,
                                                  data.f.p
                                                  //user?.uid || null //chest.uid // pro not needed bc not possible
                                              )}
                                        ${until(
                                            this.renderFromKey(data.f.p),
                                            html`<span class="opacity-50">
                                                🌐
                                            </span>`
                                        )}
                                    </div>
                                </div>
                                ${this.renderCoverArt(chest, data)}
                                ${data.t
                                    ? this.renderRecipients(chest, data.t)
                                    : ""}
                                <div
                                    class="${data.t
                                        ? "mt-4"
                                        : "mt-1"} flex justify-between text-gray-600 dark:text-gray-500 text-sm">
                                    <span
                                        @click=${() => {
                                            const total = data.b.d || 0;
                                            alert(
                                                `This B-Chest has ${total} ${
                                                    data.d.e
                                                        ? "Encrypted"
                                                        : "Public"
                                                } Diamond${
                                                    total === 1 ? "" : "s"
                                                }.`
                                            );
                                        }}
                                        title="Total Diamonds"
                                        class="inline-flex">
                                        <svg
                                            class="w-4 h-4 mr-2"
                                            fill="${data.b.d && !data.d.e
                                                ? "skyblue"
                                                : "currentColor"}"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512">
                                            <path
                                                d="M27.8 162.2l-18.5 24.9 90.5 0 6.9-130.7-78.9 105.8zM396.6 45.7L268 32 403.7 179.2 396.6 45.7zM112.5 218.3l-11.2-22-91.1 0 224.9 261.7-122.6-239.7zm2-31.2l284 0C340.6 124.3 293.3 72.9 256.6 33L114.5 187.1zm297.3 9.1l-133.9 261.8 224.8-261.7-90.9 0 0-.1zM415.7 69l-9.4-12.6 .9 17.3 6.1 113.4 90.3 0-87.9-118.1zM113.8 93.5L109.2 179.1 245 32 116.4 45.7 113.8 93.5zM401.5 196.2l-290 0c18.2 35.6 66.6 130.2 145.1 283.8L401.5 196.2z" />
                                        </svg>
                                        <span
                                            class="${data.b.d
                                                ? "text-[silver]"
                                                : "text-current"}">
                                            ${data.b.d || 0}
                                        </span>
                                    </span>
                                    <span
                                        @click=${() => {
                                            const gratuity = data.g?.a || 0;
                                            alert(
                                                gratuity === 0
                                                    ? "No gratuity was attached."
                                                    : `A gratuity of ${gratuity.toCashAmount()} was attached.`
                                            );
                                        }}
                                        title="Gratuity"
                                        class="inline-flex -mt-1">
                                        <span
                                            class="${(data.g?.a || 0) === 0
                                                ? "text-current"
                                                : "text-[silver]"}">
                                            <span class="font-black text-base">
                                                ${(
                                                    data.g?.a || 0
                                                ).toCashAmount()}
                                            </span>
                                            <span class="text-xs ml-0.5">
                                                ${data.g?.c || "USD"}
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        @click=${async () => {
                                            const links =
                                                await this.stamps.stampCountTotal(
                                                    chest.id
                                                );
                                            alert(
                                                `This B-Chest has been linked ${links} time${
                                                    links === 1 ? "" : "s"
                                                } to B-Stamps.`
                                            );
                                        }}
                                        title="Total Links"
                                        class="${data.b.v === 0
                                            ? "inline-flex"
                                            : "hidden"}">
                                        ${until(
                                            this.renderLinks(chest.id),
                                            html`<svg
                                                    class="w-5 h-5 mr-2"
                                                    fill="currentColor"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 640">
                                                    <path
                                                        transform="rotate(45 300 300)"
                                                        d="M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z" />
                                                </svg>
                                                0`
                                        )}
                                    </span>
                                    <span
                                        @click=${() => {
                                            const total =
                                                (chest.scans || 0) +
                                                (chest.views || 0);
                                            alert(
                                                `This B-Chest has been scanned and viewed ${total} time${
                                                    total === 1 ? "" : "s"
                                                }.`
                                            );
                                        }}
                                        title="Total Scans"
                                        class="${data.b.v === 0
                                            ? "inline-flex"
                                            : "hidden"}">
                                        <svg
                                            class="w-4 h-4 mr-2"
                                            fill="${(chest.scans || 0) +
                                                (chest.views || 0) ===
                                            0
                                                ? "currentColor"
                                                : "teal"}"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512">
                                            <path
                                                d="M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z" />
                                        </svg>
                                        <span
                                            class="${(chest.scans || 0) +
                                                (chest.views || 0) ===
                                            0
                                                ? "text-current"
                                                : "text-[silver]"}">
                                            ${(chest.scans || 0) +
                                            (chest.views || 0)}
                                        </span>
                                    </span>
                                </div>
                            </li>
                        `;
                    }
                )}`,
                history
            );

            initDropdowns();
        }

        this.main.hideSpinner();
        if (isScroll) this.scrollToTop();
    }

    private scrollToTop() {
        const parent = this.mints.parentElement as HTMLElement;
        parent.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        // const params = new URLSearchParams(window.location.search);
        // console.log(params.has("scroll"));
        // if (params.has("scroll")) {
        //     const url = new URL(window.location.href);
        //     url.searchParams.delete("scroll");
        //     window.history.replaceState(null, "", url.toString());
        // } else {
        //     const parent = this.mints.parentElement as HTMLElement;
        //     parent.scrollTo({
        //         top: 0,
        //         behavior: "smooth"
        //     });
        // }
    }

    private async renderLinks(id: string) {
        const total = await this.stamps.stampCountTotal(id);
        return html`
            <svg
                class="w-5 h-5 mr-2"
                fill="${total === 0 ? "currentColor" : "silver"}"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 640">
                <path
                    transform="rotate(45 300 300)"
                    d="M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z" />
            </svg>
            <span class="${total === 0 ? "text-current" : "text-[silver]"}">
                ${total}
            </span>
        `;
    }

    private renderAvatar(
        hidename: boolean,
        key: string,
        uid: string | null = null
    ) {
        return html`
            <hb-me
                class="mr-2"
                uid="${uid}"
                key="${key}"
                .hidename=${hidename}></hb-me>
        `;
    }

    // needed bc weird bug with position absolute
    private renderCoverArt(chest: any, data: any) {
        return html`
            <div
                class="relative"
                @click=${() =>
                    (window.location.hash = `#/chest/${chest.id}/${chest.type}s`)}>
                <img class="w-full py-3 rounded" src="${chest.coverPoster}" />
                <aside
                    class="absolute -ml-3 z-20 opacity-100 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <h1
                        class="${data.b.d
                            ? "mt-15 mb-0"
                            : "mt-10 mb-5"} ml-2 text-4xl font-black">
                        ${data.b.w || 0}
                    </h1>
                    <div
                        class="inline-flex ml-0 w-full text-center text-sm font-medium text-black">
                        <svg
                            class="${data.n.v
                                ? "fill-yellow-600"
                                : "fill-gray-600"} w-4 h-4 me-1.5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512">
                            <path
                                d="M128 96l0-16c0-44.2 86-80 192-80S512 35.8 512 80l0 16c0 30.6-41.3 57.2-102 70.7-2.4-2.8-4.9-5.5-7.4-8-15.5-15.3-35.5-26.9-56.4-35.5-41.9-17.5-96.5-27.1-154.2-27.1-21.9 0-43.3 1.4-63.8 4.1-.2-1.3-.2-2.7-.2-4.1zM432 353l0-46.2c15.1-3.9 29.3-8.5 42.2-13.9 13.2-5.5 26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zm0-96l0-33c0-4.5-.4-8.8-1-13 15.5-3.9 30-8.6 43.2-14.2s26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zM0 240l0-16c0-44.2 86-80 192-80s192 35.8 192 80l0 16c0 44.2-86 80-192 80S0 284.2 0 240zm384 96c0 44.2-86 80-192 80S0 380.2 0 336l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3l0 15.4zm0 80.6l0 15.4c0 44.2-86 80-192 80S0 476.2 0 432l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3z" />
                        </svg>
                        <strong id="hb-x-karat" class="me-1 hidden">
                            ${data.b.w || 0}
                        </strong>
                        Karat ${data.n.v ? "Gold" : "Silver"}
                    </div>
                    <!--<div
                        class="${data.b.d
                        ? "inline-flex"
                        : "hidden"} ml-0 w-full text-center text-sm font-medium text-black">
                        <svg
                            class="fill-pink-400 w-4.5 h-4.5 me-1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512">
                            <path
                                d="M27.8 162.2l-18.5 24.9 90.5 0 6.9-130.7-78.9 105.8zM396.6 45.7L268 32 403.7 179.2 396.6 45.7zM112.5 218.3l-11.2-22-91.1 0 224.9 261.7-122.6-239.7zm2-31.2l284 0C340.6 124.3 293.3 72.9 256.6 33L114.5 187.1zm297.3 9.1l-133.9 261.8 224.8-261.7-90.9 0 0-.1zM415.7 69l-9.4-12.6 .9 17.3 6.1 113.4 90.3 0-87.9-118.1zM113.8 93.5L109.2 179.1 245 32 116.4 45.7 113.8 93.5zM401.5 196.2l-290 0c18.2 35.6 66.6 130.2 145.1 283.8L401.5 196.2z" />
                        </svg>
                        <strong id="hb-x-carat" class="me-1">
                            ${data.b.d || 0}
                        </strong>
                        Carat Diamond
                    </div>-->
                </aside>
                <aside
                    class="absolute z-10 w-60 h-60 opacity-90 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <hb-b .heartbeat=${data.b.s}></hb-b>
                </aside>
            </div>
        `;
    }

    private async renderFromKey(key: string) {
        if (this.heartbank.user) {
            if (getSafe() === key)
                return html` <span class="opacity-100">🔒</span> `;
            else if (getLocker() === key)
                return html` <span class="opacity-100">🔐</span> `;
            else {
                const hold = await this.me.getFromAddressType(
                    key,
                    this.heartbank.user.uid
                );
                switch (hold) {
                    case "safe":
                        return html` <span class="opacity-50">🔒</span> `;
                    case "locker":
                        return html` <span class="opacity-50">🔐</span> `;
                    default:
                        return html` <span class="opacity-50">🌐</span> `;
                }
            }
        } else {
            const hold = await this.me.getFromAddressType2(key, null);
            switch (hold) {
                case "safe":
                    return html` <span class="opacity-50">🔒</span> `;
                case "locker":
                    return html` <span class="opacity-50">🔐</span> `;
                default:
                    return html` <span class="opacity-50">🌐</span> `;
            }
        } //html` <span class="opacity-50">🌐</span> `;
    }

    private async renderToKey(key: string) {
        const hold = await this.me.getToAddressType(key);
        switch (hold) {
            case "safe":
                return html` <span class="opacity-100">🔒</span> `;
            case "locker":
                return html` <span class="opacity-100">🔐</span> `;
            default:
                const hold = await this.me.getToAddressType2(
                    key,
                    this.heartbank.user?.uid || null
                );
                switch (hold) {
                    case "safe":
                        return html` <span class="opacity-50">🔒</span> `;
                    case "locker":
                        return html` <span class="opacity-50">🔐</span> `;
                    default:
                        return html` <span class="opacity-50">🌐</span> `;
                }
            //return html` <span class="opacity-50">🌐</span> `;
        }
    }

    private renderRecipients(chest: any, recipients: any) {
        return html`
            <ul
                class="w-full text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                ${until(
                    (async () => {
                        const items = await Promise.all(
                            recipients.map(
                                async (recipient: any, index: number) => {
                                    const uid = await this.me.getUserId(
                                        recipient.p
                                    );
                                    return html`
                                        <li
                                            class="${index + 1 ===
                                            recipients.length
                                                ? ""
                                                : "border-b"} 
                                            ${chest.recipients?.includes(
                                                recipient.p
                                            )
                                                ? "text-green-600 dark:text-green-400"
                                                : "text-gray-900 dark:text-white"} border-gray-200 dark:border-gray-600 inline-flex justify-between items-center w-full px-4 py-2 text-sm font-medium rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                            ${this.renderAvatar(
                                                false,
                                                recipient.p,
                                                uid
                                            )}
                                            ${until(
                                                this.renderToKey(recipient.p),
                                                html`
                                                    <span class="opacity-50"
                                                        >🌐</span
                                                    >
                                                `
                                            )}
                                        </li>
                                    `;
                                }
                            )
                        );
                        return items;
                    })(),
                    html`<li class="opacity-50 px-4 py-2">Loading...</li>`
                )}
            </ul>
        `;
    }

    // TODO: refactor each recipient has a component to reduce firestore calls
    // if user: open profile; else: copy key to clipboard
    private renderRecipients2(recipients: any) {
        return html`
            <ul
                class="w-full text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                ${recipients.map(
                    (recipient: any, index: number) => html`
                        <li
                            class="${index + 1 === recipients.length
                                ? ""
                                : "border-b"} inline-flex justify-between items-center w-full px-4 py-2 text-sm font-medium border-gray-200 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                            ${this.renderAvatar(false, recipient.p)}
                            ${until(
                                this.renderToKey(recipient.p),
                                html` <span class="opacity-50">🌐</span> `
                            )}
                        </li>
                    `
                )}
            </ul>
        `;
    }

    //// copy

    private async copyCode(data: string | Blob, heartbeat: boolean) {
        const blob = typeof data === "string" ? await fetchBlob(data) : data;
        this.copy(await this.gifToPngBlob(blob), heartbeat);
    }

    private async copy(data: string | Blob, heartbeat: boolean) {
        try {
            //await (navigator.permissions as any).query({ name: "clipboard-write" });
            if (typeof data === "string") {
                await navigator.clipboard.writeText(data);
                alert(
                    "The Short Link to this Silver B-Chest has been copied to your clipboard."
                );
            } else {
                //if (isIOS) data = await this.gifToPngBlob(data); // still doesn't work bc ios doesn't support gif or png clipboard images
                const code = new ClipboardItem({
                    [data.type]: data
                });
                await navigator.clipboard.write([code]);
                alert(
                    "The QR Code to this Silver B-Chest has been copied to your clipboard." +
                        (heartbeat
                            ? "\n\nNote: The GIF image needed to be converted to a PNG image; therefore, the heart beat showing Proof of Humanity ℠ is lost."
                            : "")
                );
            }
        } catch (error) {
            //console.error(error);
            if (typeof data !== "string")
                alert(
                    "Sorry, copying the Silver QR Code image is not supported on this device. Please download the Silver QR Code image instead."
                );
            else alert("Please allow clipboard access and try again.");
        }
    }

    private async gifToPngBlob(gifBlob: Blob): Promise<Blob> {
        const img = document.createElement("img");
        img.src = URL.createObjectURL(gifBlob);

        await new Promise((resolve) => (img.onload = resolve));

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d")!;
        ctx.drawImage(img, 0, 0);

        return new Promise((resolve) => {
            canvas.toBlob((b) => resolve(b!), "image/png");
        });
    }

    //// download

    private downloadCode(name: string, data: string | Blob) {
        downloadFile(`${name}.B.gif`, data);
    }

    private async downloadCrystal(name: string, data: string) {
        const blob = isUSDZ
            ? await this.b3.mint(data)
            : await this.b3.mint2(data);
        downloadFile(`${name}.3B.${isUSDZ ? "usdz" : "glb"}`, blob);
    }

    /// print

    private async print(data: string | Blob): Promise<void> {
        const url = typeof data === "string" ? data : URL.createObjectURL(data);
        return new Promise((resolve, reject) => {
            const printWindow = window.open("", "_blank");
            if (!printWindow) {
                reject(new Error("Failed to open print window"));
                return;
            }

            printWindow.document.write(`
            <html>
                <head>
                    <title>HeartBank® Chest</title>
                    <style>
                        body, html {
                            margin: 0;
                            padding: 0;
                            background: skyblue;
                        }
                        body {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100vw;
                            height: 100vh;
                        }
                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    </style>
                </head>
                <body>
                    <img src="${url}" onload="window.focus();window.print();" onafterprint="window.close();" />
                </body>
            </html>
        `);

            printWindow.document.close();
            resolve();
        });
    }

    //// share

    private async shareLink(
        name: string,
        title: string,
        text: string,
        url: string,
        avatar: string,
        code: string,
        jewel: string
    ) {
        const file1 = new File([await fetchBlob(avatar)], `${name}.B.gif`, {
            type: "image/gif"
        });
        const file2 = new File([await fetchBlob(code)], `${name}.code.B.gif`, {
            type: "image/gif"
        });
        const file3 = new File([await fetchBlob(jewel)], `${name}.B.mp4`, {
            type: "video/mp4"
        });

        this.shares(
            title,
            text, /// \n\n${url}
            url,
            [file1, file3, file2]
        );
    }

    private async shareCode(
        name: string,
        title: string,
        text: string,
        data: Blob,
        jewel: string
    ) {
        const code = new File([data], `${name}.B.gif`, { type: "image/gif" });
        const video = new File([await fetchBlob(jewel)], `${name}.B.mp4`, {
            type: "video/mp4"
        });
        this.shares(
            title,
            text, // \n\n${this.link} // cannot paste on ios
            this.link,
            [video, code]
        );
    }

    // TODO: check: can't share on ios, maybe can share on android?
    private async shareCrystal(
        name: string,
        title: string,
        text: string,
        data: string,
        jewel: string
    ) {
        const blob = isUSDZ
            ? await this.b3.mint(data)
            : await this.b3.mint2(data);

        const crystal = new File(
            [blob],
            `${name}.3B.${isUSDZ ? "usdz" : "glb"}`,
            {
                type: isUSDZ ? "model/vnd.usdz+zip" : "model/gltf-binary"
            }
        );

        const video = new File([await fetchBlob(jewel)], `${name}.B.mp4`, {
            type: "video/mp4"
        });

        this.shares(
            title,
            text, // \n\n${this.link}
            this.link,
            [video, crystal]
        );
    }

    private async shareTimeLock(
        name: string,
        title: string,
        text: string,
        url: string,
        jewel: string
    ): Promise<void> {
        const file = new File([await fetchBlob(jewel)], `${name}.B.mp4`, {
            type: "video/mp4"
        });
        await this.share(title, text, url, file);
    }

    private async share(
        title: string,
        text: string,
        url: string,
        file: File
    ): Promise<void> {
        await this.shares(title, text, url, [file]);
    }

    private async shares(
        title: string,
        text: string,
        url: string,
        files: File[]
    ): Promise<void> {
        const shareData = {
            title,
            text:
                title +
                "\n\n" +
                text +
                "\n\nThank with HeartBank®\nWhatsApp: +1 (800) 59-THANK\n",
            url,
            files
        };

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Data shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled: ", error);
                } else {
                    console.error("Error sharing files: ", error);
                    // for (const file of files) downloadFile(file.name, file);
                    // alert(
                    //     "This Silver B-Chest wrapped inside a 3B Crystal has been downloaded to your device for sharing."
                    // );
                    alert(
                        "Sorry, sharing this Silver B-Chest as a 3B Crystal is not supported on this device. Please download it instead to share."
                    );
                }
            }
        } else alert("Sorry, Web Share is not supported on this device.");
    }
}
